import { createApp } from 'vue'
import App from './App.vue'
const app = createApp(App)

// 导入element-plus
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import VxeUITable from 'vxe-table'
import 'vxe-table/lib/style.css'
// 导入map
import Vue3BaiduMapGL from 'vue3-baidu-map-gl'
//
import '@/assets/css/style.css'
// 导入echarts
import * as echarts from "echarts"
app.config.globalProperties.$echarts = echarts //全局挂载echarts
// 导入router
import router from "@/router/index"

// 使用导入的包
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(ElementPlus)
app.use(router)
app.use(Vue3BaiduMapGL)
app.use(VxeUITable)

// 挂载根页面
app.mount('#app')
